<template>
	<div>
		<div class="register">
			<div class="title">注册账号</div>
			<el-form :model="form" :rules="formRules" status-icon ref="form" label-width="0px" style="width: 360px;">
				<el-form-item label="" prop="phone">
					<el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
				</el-form-item>

				<el-form-item label="" prop="code">
					<el-input placeholder="请输入短信验证码" v-model="form.code">
						<template slot="append">
							<el-button @click="sendCode">{{ text }}</el-button>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="" prop="password">
					<el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item label="" prop="repassword">
					<el-input type="password" v-model="form.repassword" placeholder="请输入确认密码"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button style="width: 100%;" @click.native.prevent="handleSubmit" native-type="submit" :loading="loading"
						type="primary">立即注册</el-button>
				</el-form-item>
				<el-form-item>
					<div class="links">
						<router-link :to="{ path: '/auth/login' }">立即登录</router-link>
						<router-link :to="{ path: '/auth/forget' }">忘记密码</router-link>
					</div>
				</el-form-item>
			</el-form>
		</div>

		<!-- 滑动验证码 -->
		<Verify ref="verify" @success="captchaSuccess" mode="pop" :captchaType="form.captchaType"
			:imgSize="{ width: '330px', height: '155px' }"></Verify>
	</div>
</template>

<script>
import { register } from "@/api/auth";
import { sendCode } from "@/api/common";
import { validatePhone } from "@/utils/validate";
import { getStorage } from "@/utils/auth";
//引入组件
import Verify from "@/components/verifition/Verify";

export default {
	name: 'AuthRegister',
	components: {
		Verify
	},
	computed: {

	},
	data() {
		var validatePwd = (rule, value, callback) => {
			const passwordPattern = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{8,}$/
			if (value === '') {
				callback(new Error('请输入密码'));
			} else if (!passwordPattern.test(value)) {
				callback(new Error('密码长度至少8位，数字/字母/特殊字符至少包含三种'));
			} else {
				callback();
			}
		}
		var validateRepeatPwd = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.form.password) {
				callback(new Error('两次输入密码不一致'))
			} else {
				callback()
			}
		}
		return {
			loading: false,
			disabled: false,
			countdown: 60,
			text: "发送验证码",
			config: {},
			form: {
				phone: getStorage("loginPhone") || '',
				password: '',
				repassword: '',
				code: '',
				captchaType: "blockPuzzle",
				captchaVerification: "",
				csrf: "",
			},
			//0登录1发送验证码
			method: 0,
			timer: null,
			formRules: {
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' }
				],
				code: [
					{ required: true, message: '请输入短信验证码', trigger: 'blur' }
				],
				password: [
					{ required: true, validator: validatePwd, trigger: 'blur' }
				],
				repassword: [
					{ required: true, validator: validateRepeatPwd, trigger: 'blur' }
				]
			}
		}
	},
	mounted() {

	},
	methods: {
		sendCode() {
			const that = this
			const _form = that.form;
			if (that.disabled) return
			if (!_form.phone) {
				this.$message({
					type: 'error',
					message: '请输入手机号'
				});
				return;
			}
			if (!validatePhone(_form.phone)) {
				this.$message({
					type: 'error',
					message: '请输入正确的手机号码'
				});
				return;
			}
			console.log(_form)
			if (!_form.captchaVerification) {
				that.method = 1;
				this.$refs.verify.show()
				return;
			}
			that.disabled = true
			sendCode(that.form).then((res) => {
				that.timer = setInterval(() => {
					that.countdown--
					this.text = "重新发送(" + that.countdown + "s)"
					if (that.countdown == 0) {
						that.disabled = false
						that.text = '发送验证码'
						that.countdown = 60
						clearInterval(that.timer)
					}
				}, 1000)

				if (res.code == 0) {
					this.form.csrf = res.data.csrf
					this.$message({
						type: 'success',
						message: '短信发送成功'
					});
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					});
				}
			}).catch((err) => {
				console.log(err)
			})
		},
		captchaSuccess(params) {
			console.log(params);
			this.form = {
				...this.form,
				...params,
			}
			this.sendCode()
			// params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
		},
		//提交注册请求
		handleSubmit() {
			const _form = Object.assign({}, this.form);
			if (!_form.csrf) {
				this.$message({
					type: 'error',
					message: '请获取短信验证码'
				});
				return;
			}
			this.$refs.form.validate((valid, error) => {
				if (valid) {
					this.loading = true;
					register(_form).then(res => {
						this.loading = false;
						this.form.csrf = '';
						this.$message.success('注册成功，请登录！')
						this.$router.push('/auth/login')
					}).catch(() => {
						this.loading = false;
					});
				} else {
					console.log(error)
				}
			});
		},
	}

}
</script>

<style lang="scss" scoped>
.register {
	width: 67.6%;
	min-width: 1200px;
	background-color: #f7f7f7;
	padding: 30px 0 100px 0;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-bottom: 18px;

	.links {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 400;
		font-style: normal;
		font-size: 14px;
		color: rgba(95, 169, 180, 0.972549019607843);
		line-height: normal;
	}

	.title {
		font-weight: 650;
		font-style: normal;
		font-size: 20px;
		color: #555555;
		text-align: center;
		margin-bottom: 30px;
	}
}
</style>
